export default {
    IS_LOGIN(state) {
        state.loginStatus = true;
    },
    NOT_LOGIN(state) {
        state.loginStatus = false;
    },
    HAS_LOGGED_OUT(state) {
        state.loginStatus = null;
    },
    SET_SAFETY_VERIFICATION(state, safetyVerification) {
        localStorage.setItem('safetyVerification', JSON.stringify(safetyVerification))
        state.safetyVerification = safetyVerification
    },
    SET_USER_INFO(state, userInfo) {
        state.userInfo = userInfo;
    },
    SET_WALLET_INFO(state, walletInfo) {
        if (typeof walletInfo === 'Object') {
            state.walletInfo = Object.assign({}, walletInfo, {
                wallet_company: walletInfo.wallet_company || {},
                wallet_person: walletInfo.wallet_person || {},
            });
        } else {
            state.walletInfo = walletInfo;
        }
    },
};


// WEBPACK FOOTER //
// ./src/vuex/mutations.js